import * as yup from 'yup';

const PriorityElementSchema = yup.object({
  name: yup.string().required('Name is required'),
  type: yup.string().required('Element type is required'),
  // profile: yup.array().required('Profile element is required'),
});

export { PriorityElementSchema };
